import { NavModelItem } from '@grafana/data';
import config from 'app/core/config';

export const PMM_STT_PAGE: NavModelItem = {
  id: 'database-checks',
  icon: 'percona-database-checks',
  text: 'Advisor Checks',
  subTitle: 'Percona Advisor Checks',
  url: `${config.appSubUrl}/pmm-database-checks`,
  breadcrumbs: [
    {
      title: 'Advisor Checks',
      url: `${config.appSubUrl}/pmm-database-checks`,
    },
  ],
  children: [
    {
      id: 'failed-checks',
      text: 'Failed Checks',
      url: `${config.appSubUrl}/pmm-database-checks/failed-checks`,
      hideFromMenu: true,
    },
    {
      id: 'all-checks',
      text: 'All Checks',
      url: `${config.appSubUrl}/pmm-database-checks/all-checks`,
      hideFromMenu: true,
    },
  ],
};

export const PMM_DBAAS_PAGE: NavModelItem = {
  id: 'dbaas',
  text: 'DBaaS',
  subTitle: 'Percona DBaaS',
  icon: 'database',
  url: `${config.appSubUrl}/dbaas`,
  breadcrumbs: [
    {
      title: 'DBaaS',
      url: `${config.appSubUrl}/dbaas`,
    },
  ],
  children: [
    {
      id: 'kubernetes',
      text: 'Kubernetes Cluster',
      url: `${config.appSubUrl}/dbaas/kubernetes`,
      hideFromMenu: true,
    },
    {
      id: 'dbclusters',
      text: 'DB Cluster',
      url: `${config.appSubUrl}/dbaas/dbclusters`,
      hideFromMenu: true,
    },
  ],
};

export const PMM_BACKUP_PAGE: NavModelItem = {
  id: 'backup',
  icon: 'history',
  text: 'Backup',
  subTitle: 'Percona Backups',
  url: `${config.appSubUrl}/backup`,
  breadcrumbs: [
    {
      title: 'Backup',
      url: `${config.appSubUrl}/backup`,
    },
  ],
  children: [
    {
      id: 'backup-inventory',
      text: 'Backup Inventory',
      url: `${config.appSubUrl}/backup/inventory`,
      hideFromMenu: true,
    },
    {
      id: 'restore-history',
      text: 'Restore History',
      url: `${config.appSubUrl}/backup/restore`,
      hideFromMenu: true,
    },
    {
      id: 'scheduled-backups',
      text: 'Scheduled Backups',
      url: `${config.appSubUrl}/backup/scheduled`,
      hideFromMenu: true,
    },
    {
      id: 'storage-locations',
      text: 'Storage Locations',
      url: `${config.appSubUrl}/backup/locations`,
      hideFromMenu: true,
    },
  ],
};

export const PMM_ALERTING_PAGE: NavModelItem = {
  id: 'integrated-alerting',
  icon: 'bell',
  text: 'Integrated Alerting',
  url: `${config.appSubUrl}/integrated-alerting`,
  subTitle: 'Percona Integrated Alerting',
  breadcrumbs: [
    {
      title: 'Integrated Alerting',
      url: `${config.appSubUrl}/integrated-alerting`,
    },
  ],
  children: [
    {
      id: 'integrated-alerting-alerts',
      text: 'Alerts',
      url: `${config.appSubUrl}/integrated-alerting/alerts`,
    },
    {
      id: 'integrated-alerting-rules',
      text: 'Alert Rules',
      url: `${config.appSubUrl}/integrated-alerting/alert-rules`,
    },
    {
      id: 'integrated-alerting-templates',
      text: 'Alert Rule Templates',
      url: `${config.appSubUrl}/integrated-alerting/alert-rule-templates`,
    },
    {
      id: 'integrated-alerting-notification-channels',
      text: 'Notification Channels',
      url: `${config.appSubUrl}/integrated-alerting/notification-channels`,
    },
  ],
};

export const PMM_INVENTORY_PAGE: NavModelItem = {
  id: 'inventory',
  icon: 'percona-inventory',
  text: 'PMM Inventory',
  url: `${config.appSubUrl}/inventory`,
  subTitle: 'Percona PMM Inventory',
  breadcrumbs: [
    {
      title: 'PMM Inventory',
      url: `${config.appSubUrl}/inventory`,
    },
  ],
  children: [
    {
      id: 'inventory-services',
      text: 'Services',
      url: `${config.appSubUrl}/inventory/services`,
      hideFromMenu: true,
    },
    {
      id: 'inventory-agents',
      text: 'Agents',
      url: `${config.appSubUrl}/inventory/agents`,
      hideFromMenu: true,
    },
    {
      id: 'inventory-nodes',
      text: 'Nodes',
      url: `${config.appSubUrl}/inventory/nodes`,
      hideFromMenu: true,
    },
  ],
};

export const PMM_ADD_INSTANCE_PAGE: NavModelItem = {
  id: 'add-instance',
  url: `${config.appSubUrl}/add-instance`,
  icon: 'percona-add',
  subTitle: 'Add Instance to PMM',
  text: 'Add Instance',
  hideFromTabs: true,
};

export const getPmmSettingsPage = (alertingEnabled = false): NavModelItem => {
  const children: NavModelItem[] = [
    {
      id: 'settings-metrics-resolution',
      text: 'Metrics Resolution',
      url: `${config.appSubUrl}/settings/metrics-resolution`,
    },
    {
      id: 'settings-advanced',
      text: 'Advanced Settings',
      url: `${config.appSubUrl}/settings/advanced-settings`,
    },
    {
      id: 'settings-ssh',
      text: 'SSH Key',
      url: `${config.appSubUrl}/settings/ssh-key`,
    },
    {
      id: 'settings-alert-manager',
      text: 'Alertmanager Integration',
      url: `${config.appSubUrl}/settings/am-integration`,
    },
    {
      id: 'settings-percona-platform',
      text: 'Percona Platform',
      url: `${config.appSubUrl}/settings/percona-platform`,
    },
  ];

  if (alertingEnabled) {
    children.push({
      id: 'settings-communication',
      text: 'Communication',
      url: `${config.appSubUrl}/settings/communication`,
    });
  }
  const page: NavModelItem = {
    id: 'settings',
    icon: 'percona-setting',
    text: 'Settings',
    url: `${config.appSubUrl}/settings`,
    subTitle: 'Percona Settings',
    breadcrumbs: [
      {
        title: 'Settings',
        url: `${config.appSubUrl}/settings`,
      },
    ],
    children,
  };

  return page;
};

export const PMM_TICKETS_PAGE: NavModelItem = {
  id: 'tickets',
  icon: 'ticket',
  text: 'List of tickets opened by Customer Organization',
  subTitle: 'Percona Support Tickets from Portal',
  url: `${config.appSubUrl}/tickets`,
};

export const PMM_ENTITLEMENTS_PAGE: NavModelItem = {
  id: 'entitlements',
  icon: 'cloud',
  text: 'Entitlements',
  subTitle: 'Percona Entitlements',
  url: `${config.appSubUrl}/entitlements`,
};
